import withProps from 'recompose/withProps';
import { FormattedMessage } from 'react-intl';

export default withProps({
  id: 'stop-page.title-short',
  defaultMessage: 'Stop',
})(FormattedMessage);
